import { render, staticRenderFns } from "./drugData.vue?vue&type=template&id=304356dd&scoped=true&"
import script from "./drugData.vue?vue&type=script&lang=js&"
export * from "./drugData.vue?vue&type=script&lang=js&"
import style0 from "./drugData.vue?vue&type=style&index=0&id=304356dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304356dd",
  null
  
)

export default component.exports